import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/mobile",
    name: "Mobile",
    component: () => import("../views/Home/Mobile.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/Index.vue"),
    children: [
      {
        path: "/",
        name: "Main",
        component: () => import("../views/Home/Main.vue"),
      },
      {
        path: "/self",
        name: "Self",
        component: () => import("../views/Home/Self.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
